<script lang="ts">
  import { Hospital } from '../../../lib/api';

  let { limit = 8 }: { limit?: number } = $props();
  let items = $state<any[]>([]);
  let error = $state<string | null>(null);

  function fmt(iso?: string) {
    if (!iso) return '—';
    try {
      return new Date(iso).toLocaleString('es-GT', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
    } catch { return iso; }
  }

  async function cargar() {
    error = null;
    try {
      items = (await Hospital.traspasos()).slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header><h3>Traspasos recientes (SBAR)</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if items.length === 0 && !error}
    <p class="empty">Sin traspasos registrados.</p>
  {:else}
    <ul>
      {#each items as t, i (t.id ?? i)}
        <li>
          <strong>Cama {t.camaOrigenNumero ?? t.camaId?.slice?.(0, 6) ?? '—'}</strong>
          <span>{t.motivo ?? t.resumen ?? 'Traspaso'} · {fmt(t.creadoEn ?? t.fecha)}</span>
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-elevated); height: 100%; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); }
  h3 { margin: 0; font-size: 0.9rem; }
  header button { border: 1px solid var(--border); background: var(--bg-surface); border-radius: 6px; cursor: pointer; padding: 0.2rem 0.5rem; }
  ul { list-style: none; margin: 0; padding: 0; max-height: 280px; overflow: auto; }
  li { padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--border); }
  strong { display: block; font-size: 0.85rem; }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
